import { createRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { Route as appRoute } from '../../_app'
import { useRequireAdmin } from '../../../lib/me-context'
import { AdminShell } from '../../../components/admin/AdminShell'
import { AnalyticsCards } from '../../../components/admin/AnalyticsCards'

/**
 * Admin overview (`/admin`) — at-a-glance operational health. Guards on the
 * admin role via {@link useRequireAdmin} (non-admins are bounced to
 * `/dashboard`), then renders the shared admin chrome + the analytics
 * stat-card grid.
 */
export const Route = createRoute({
  getParentRoute: () => appRoute,
  path: '/admin/',
  component: AdminIndexPage,
})

function AdminIndexPage() {
  const { t } = useTranslation('admin')
  const isAdmin = useRequireAdmin()

  if (!isAdmin) {
    // The guard is scheduling a redirect to /dashboard; render nothing so
    // admin chrome never flashes to a non-admin during the redirect frame.
    return null
  }

  return (
    <AdminShell active="overview" title={t('overviewTitle')}>
      <AnalyticsCards />
    </AdminShell>
  )
}
